import styled from 'styled-components';
import {
  display,
  dimension,
  position,
  overflow,
  padding,
  margin,
  background,
  flexParent,
  flexChild,
  border,
  animation,
  font,
} from '../styleHelper2';

const Container = styled.div`
  ${display()}
  ${dimension()}
    ${position()}
    ${overflow()}
    ${padding()}
    ${margin()}
    ${background()}
    ${flexParent()}
    ${flexChild()}
    ${border()}
    ${animation()}
    ${font()}
`;

export default Container;
